import {
  FETCH_FACTORING_PROFILE_REQUEST,
  FETCH_FACTORING_PROFILE_SUCCESS,
  FETCH_FACTORING_PROFILE_FAILURE
} from "../types";

const fetchFactoringProfile = (state, { type, payload }) => {
  switch (type) {
    case FETCH_FACTORING_PROFILE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_FACTORING_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        factoringProfileSuccess: payload
      };
    case FETCH_FACTORING_PROFILE_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return {
        ...state
      };
  }
};

export default fetchFactoringProfile;
